/**
 * Apre il pannello Smile dai pulsanti del sito.
 * Usa SmileUI.ready() (API ufficiale) e fallback a ricarica con ?smile_deep_link=
 */
(function () {
  function panelVisible() {
    var panel = document.querySelector('.smile-panel-frame-container, .smile-panel-frame');
    if (!panel) return false;
    var r = panel.getBoundingClientRect();
    return r.width > 100 && r.height > 100;
  }

  function openNow(deepLink) {
    if (!(window.SmileUI && typeof window.SmileUI.openPanel === 'function')) return false;
    try {
      window.SmileUI.openPanel({ deep_link: deepLink || 'home' });
      return true;
    } catch (e) {
      try {
        window.SmileUI.openPanel();
        return true;
      } catch (e2) {
        return false;
      }
    }
  }

  function openSmilePanel(deepLink) {
    var link = deepLink || 'home';

    function attempt() {
      return openNow(link);
    }

    if (attempt()) return;

    if (typeof window.loadSmileSdk === 'function') {
      try {
        window.loadSmileSdk();
      } catch (e) {}
    }

    // Attendi init ufficiale Smile
    if (window.SmileUI && typeof window.SmileUI.ready === 'function') {
      try {
        window.SmileUI.ready()
          .then(function () {
            attempt();
          })
          .catch(function () {});
      } catch (e) {}
    }

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (attempt() || panelVisible() || tries > 40) {
        clearInterval(timer);
        // Se dopo ~10s non è aperto, ricarica con deep link nativo Smile
        if (!panelVisible() && tries > 40) {
          var url = new URL(window.location.href);
          if (url.searchParams.get('smile_deep_link') !== link) {
            url.searchParams.set('smile_deep_link', link);
            url.hash = '';
            window.location.href = url.toString();
          }
        }
      }
    }, 250);
  }

  window.slOpenSmile = openSmilePanel;

  function onClick(e) {
    var el = e.target;
    while (el && el !== document && !(el.getAttribute && el.getAttribute('data-smile-deep-link'))) {
      el = el.parentNode;
    }
    if (!el || el === document) return;
    var deepLink = el.getAttribute('data-smile-deep-link');
    if (!deepLink) return;

    // Se Smile è pronto: apri senza ricaricare. Altrimenti lascia il link nativo.
    if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
      e.preventDefault();
      openSmilePanel(deepLink);
      return;
    }

    // Smile non pronto: non bloccare — il browser segue href=?smile_deep_link=...
  }

  function boot() {
    document.addEventListener('click', onClick, true);

    try {
      var params = new URLSearchParams(window.location.search);
      var fromQuery = params.get('smile_deep_link');
      if (fromQuery) {
        var start = function () {
          openSmilePanel(fromQuery);
        };
        if (window.SmileUI && typeof window.SmileUI.ready === 'function') {
          window.SmileUI.ready().then(start).catch(start);
        } else {
          // Smile carica dopo: riprova
          setTimeout(start, 500);
          setTimeout(start, 1500);
          setTimeout(start, 3000);
        }
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
